export default function anonymous(context
) {
var out=''+( context.object.getNotationString() );return out;
}